import React from 'react';
import { Menu, Button, Radio, Checkbox } from 'antd';
import cn from 'classnames';
import styles from './TableFilterDropdown.module.scss';

const getKeys = (selectedKeys, filterMultiple, value) => {
  if (selectedKeys && filterMultiple) {
    return selectedKeys.includes(value)
      ? selectedKeys.filter((selectedKey) => selectedKey !== value)
      : [...selectedKeys, value];
  }

  return [value];
};

const TableFilterDropdown = ({
  clearFilters,
  confirm,
  filters,
  selectedKeys,
  setSelectedKeys,
  filterMultiple = true,
  menuClassName,
}) => {
  const handleMenuClick = ({ item }) => {
    const data = getKeys(selectedKeys, filterMultiple, item.props.value);

    setSelectedKeys(data);
  };

  return (
    <div className={styles.root}>
      <Menu
        className={cn(styles.menu, menuClassName)}
        selectedKeys={selectedKeys}
        onClick={handleMenuClick}
      >
        {filters.map((filter) => (
          <Menu.Item
            className={cn({
              [styles.selected]: selectedKeys?.includes(filter.value),
            })}
            key={filter.value}
            value={filter.value}
          >
            {filterMultiple ? (
              <Checkbox
                className={styles.checkbox}
                value={filter.value}
                checked={selectedKeys?.includes(filter.value)}
              />
            ) : (
              <Radio
                className={styles.checkbox}
                value={filter.value}
                checked={selectedKeys?.includes(filter.value)}
              />
            )}

            {filter.text}
          </Menu.Item>
        ))}
      </Menu>
      <div className={styles.actionsWrap}>
        <Button type="primary" onClick={confirm}>
          Ок
        </Button>
        <Button onClick={clearFilters}>Сбросить</Button>
      </div>
    </div>
  );
};

export default TableFilterDropdown;
